import { Dispatch } from "redux"

export const toggleDarkMode = (nextMode: boolean) => (dispatch: Dispatch) => {
  dispatch({
    type: "TOGGLE_DARK_MODE",
    payload: nextMode,
  })
}
